import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemImportCloudRoute: InvariantJiraRoute = {
	name: 'global-settings-system-import-cloud',
	path: '/secure/admin/CloudImport([!%]?[\\w]*).jspa',
};
